import PropTypes from 'prop-types'

import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import CardVehicleSpecs from '../CardVehicleSpecs/index.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-StepVehicleSelect-ListVehicleOptions'

const ListVehicleOptions = ({onClickCard, unCommonData, vehicleList}) => {
  const handleClickCard = ({vehicle}) => {
    onClickCard({vehicle})
  }

  return (
    <div className={BASE_CLASS_NAME}>
      <TitleBasic
        as={titleBasicTags.h2}
        color={titleBasicColors.currentColor}
        description={`Hemos encontrado más de un resultado para tu vehículo. Révisalos y selecciona el que se corresponda al tuyo.`}
        size={titleBasicSizes.xss}
        title={`Selecciona la versión de tu vehículo`}
      />
      <div className={`${BASE_CLASS_NAME}-list`}>
        {vehicleList.map(vehicle => {
          const [first, second = '', ...rest] = vehicle.version.split(' ')
          const title = `${first} ${second}`

          const vehicleData = {}
          Object.keys(unCommonData).forEach(spec => {
            vehicleData[spec] = vehicle[spec]
          })
          vehicleData.version = rest.join(' ')

          return (
            <CardVehicleSpecs
              onClickCard={() => handleClickCard({vehicle})}
              key={vehicle.version}
              title={title}
              vehicleData={vehicleData}
            />
          )
        })}
      </div>
    </div>
  )
}

ListVehicleOptions.displayName = 'ListVehicleOptions'

ListVehicleOptions.propTypes = {
  onClickCard: PropTypes.func,
  unCommonData: PropTypes.object.isRequired,
  vehicleList: PropTypes.array.isRequired
}

export default ListVehicleOptions
